import {FaWhatsapp} from "react-icons/fa";
interface IFooter {
    fixed?: boolean
}
export default function Footer({ fixed = true }: IFooter) {
    return(
        <footer className={`w-full  shadow-sm bg-[#003641] ${fixed ? 'fixed' : ''} bottom-0 left-0 z-40 text-white`}>
            <div className="w-full mx-auto max-w-screen-xl p-3 md:flex md:items-center md:justify-between">
                    <span className="text-sm sm:text-center ">
                        E-mail: <a href="mailto:5004.bndu@sicoob.com.br">5004.bndu@sicoob.com.br</a>
                    </span>
                <div className="flex flex-wrap items-center mt-3 text-sm font-medium  sm:mt-0">
                    <a href="https://wa.me/5562996271244?text=Quero%20saber%20mais%20sobre%20o%20produto"
                       target={'_blank'}
                       className="hover:underline me-4 md:me-6"
                    >
                        <FaWhatsapp size={30} color={'FFF'} />
                    </a>

                </div>
            </div>
        </footer>
    )
}